/* eslint-disable react-hooks/exhaustive-deps */
import { Link } from "react-router-dom";
import React, { useEffect, useState } from "react";
import { useDoSeeDataContext } from "../../../context/doSeeData/DoSeeDataContext";
import { pushOneAdvertisement } from "../../../middlewares/sysNavigation/SysNavigation";
import { BreadCrumbComponent } from "../../../middlewares/breadCrumb/BreadCrumbComponent";
import {
  Modal,
  GoBack,
  Search,
  MyButton,
  Pagination,
  DashboardIntro,
} from "../../home/component/Component";
import { _TYPES_ } from "../utils/types";
import { _PAGE_SIZE_ } from "../../../middlewares/other/tools";
import { useGeoPositionContext } from "../utils/geoPosition";

const addRoute = "/data/advertisement/add";
const editRoute = "/data/advertisement/edit";
const doseeDataRoutes = "/dosee/data";

const Overview = () => {
  const {
    advertisements,
    advertisementCount,
    fetchDoSeeData,
    fetchSponsorships,
    sponsorships,
  } = useDoSeeDataContext();
  const [advertisementsList, setAdvertisementsList] = useState([]);
  const [page, setPage] = useState(1);
  const [pageSize, setPageSize] = useState(_PAGE_SIZE_);

  useEffect(() => {
    if (!sponsorships) fetchSponsorships();
  }, [sponsorships]);

  const {
    country_id,
    entry_label,
    first_level_id,
    fourth_level_id,
    second_level_id,
    third_level_id,
  } = useGeoPositionContext();

  const data_request_body = {
    country_id,
    first_level_id,
    second_level_id,
    third_level_id,
    fourth_level_id,
    content: _TYPES_.ADV,
  };

  useEffect(() => {
    if (!advertisements) fetchDoSeeData(data_request_body, page, pageSize);
    setAdvertisementsList(advertisements);
  }, [advertisements]);

  const SearchList = (e) => {
    const key = e.target.value.toString().toLowerCase();
    let searchArray = [];
    advertisements.map((adv) => {
      if (adv.title.toString().toLowerCase().includes(key))
        return searchArray.push(adv);
      return true;
    });

    setAdvertisementsList(searchArray);
    if (key === "") setAdvertisementsList(advertisements);
  };

  return (
    <div className="p-3 lg:p-4  h-full overflow-y-auto rounded-b-xl bg-gray-50">
      <BreadCrumbComponent />
      <GoBack props={{ route: doseeDataRoutes }} />
      <div className="my-3">
        <DashboardIntro
          props={{ intro: `Advertisements`, name: entry_label }}
        />
      </div>

      <div className="flex flex-col justify-center">
        <Search
          props={{
            title: "Advertisement",
            onChange: (e) => SearchList(e),
          }}
        />
        <div className="w-full flex justify-end my-5">
          {country_id ? (
            <Link to={addRoute}>
              <MyButton
                title="Add Advertisement"
                className="py-3 px-8 bg-blue-900 hover:bg-blue-600"
                onClick={() => {}}
              />
            </Link>
          ) : null}
        </div>

        <div className="mb-5 overflow-y-auto w-full py-2">
          <table className="table-auto w-full border-collapse border border-gray-300 text-xs text-left">
            <thead>
              <tr className="space-x-2">
                <th className="border p-2 lg:px-4 font-bold w-1/3">Title</th>
                <th className="border p-2 lg:px-4 font-bold w-1/3">
                  Start Date
                </th>
                <th className="border text-center w-1/3">Action</th>
              </tr>
            </thead>
            <tbody className="space-x-2 text-left border-gray-300">
              {sponsorships && sponsorships?.data ? (
                sponsorships?.data?.map((adv, key) => (
                  <tr key={key}>
                    <td className="border px-2 lg:px-4 w-1/3">{adv?.title}</td>
                    <td className="border px-2 lg:px-4 w-1/3">
                      {adv?.start_date}
                    </td>
                    <td className="border w-1/3">
                      <ActionButton props={adv} />
                    </td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td className="border px-2 lg:px-4 w-1/3">...</td>
                  <td className="border px-2 lg:px-4 w-1/3">...</td>
                  <td className="border px-2 lg:px-4 w-1/3">...</td>
                </tr>
              )}
            </tbody>
          </table>
        </div>

        <Pagination
          page={page}
          setPage={setPage}
          pageSize={pageSize}
          setPageSize={setPageSize}
          total_items={sponsorships?.count}
          callbackFunction={(p, size) => {
            fetchDoSeeData(data_request_body, p, size);
          }}
        />
      </div>
    </div>
  );
};

/**
 *  @author Ntavigwa Bashombe
 * @param {*} props
 * @returns
 */
const ActionButton = ({ props }) => {
  const { advertisements, setDataState, deleteOneContent } =
    useDoSeeDataContext();

  const [showModal, setShowModal] = useState(false);

  const dosee_ads_id = props?.dosee_ads_id;
  const advertisement_title = props?.title;
  const advertisement = props;

  const deleteOneAdvertisementById = async (dosee_ads_id) => {
    const { status } = await deleteOneContent({
      data_id: dosee_ads_id,
      content: _TYPES_.ADV,
    });
    if (status === 200) {
      if (advertisements) {
        setDataState({
          data: advertisements.filter(
            (adv) => adv.dosee_ads_id !== dosee_ads_id
          ),
          content: _TYPES_.ADV,
        });
        setShowModal(false);
      }
    }
  };

  return (
    <>
      <Modal
        props={{
          name: advertisement_title,
          showModal: showModal,
          setShowModal: () => setShowModal(false),
          delete: () => deleteOneAdvertisementById(dosee_ads_id),
        }}
      />

      <div className="flex flex-row justify-end items-center px-2 py-3 space-x-4 text-xs">
        <Link to={editRoute}>
          <MyButton
            title="Edit"
            className={`py-3 px-8 bg-blue-800 hover:bg-blue-600`}
            onClick={() => pushOneAdvertisement(advertisement)}
          />
        </Link>
        <MyButton
          title="Delete"
          className={`py-3 px-8 bg-red-800 hover:bg-red-600`}
          onClick={() => setShowModal(true)}
        />
      </div>
    </>
  );
};

export default Overview;
